export default __webpack_public_path__ + "static/media/tabuleiro-desfocado.d5928bf3.webp";